import React, { useEffect, useState } from "react";
import {
  NOTIFICATIONS_API,
  ROLL_CALL_API_BASE_URL,
} from "../../RollCallConfig/RollCallConfig";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom/dist";
import { Spin } from "antd";

import PropTypes from "prop-types";
// import { Offcanvas } from "bootstrap";

const SendNotification = ({ onClose, isOpen }) => {
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [emailList, setEmailList] = useState("");
  const [managerEmail, setManagerEmail] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");
    const email = sessionStorage.getItem("userData");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
      setManagerEmail(email);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      if (tokenData && superIdData) {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/emp/getEmployees?superid=${superIdData}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch employees");
          }

          const data = await response.json();
          if (data.status) {
            const employees = data.ResultData || [];

            const emails = employees
              ?.map((emp) => emp.emailid)
              ?.filter((email) => !!email)
              ?.join(",");
            setEmailList(emails);
          } else {
            console.error("Error fetching employees:", data.ErrorMsg);
          }
        } catch (error) {
          console.error("Error fetching employees:", error);
        }
      }
    };

    fetchEmployeeData();
  }, [superIdData, tokenData]);

  const handleSend = async (event) => {
    event.preventDefault();
    setLoadingBtn(true);

    if (tokenData && superIdData) {
      if (!subject || !message) {
        Swal.fire({
          title: "Validation Error",
          text: "Please fill in both Subject and Message.",
          icon: "warning",
        });
        setLoadingBtn(false);
        return;
      }

      const payload = {
        superid: superIdData,
        toaddr: managerEmail,
        message: `<body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #e9ecf1;">
    <table cellpadding="0" cellspacing="0" width="100%" style="background-color: #e9ecf1; padding: 20px 0;">
        <tr>
            <td align="center">
                <table cellpadding="0" cellspacing="0" width="600"
                    style="background-color: #ffffff; border: 1px solid #ccc; box-shadow: 0 2px 6px rgba(0,0,0,0.08); border-radius: 6px; overflow: hidden;">

                    <tr>
                        <td align="center" style="background-color: #FE9F43; padding: 20px;">
                            <div
                                style="background-color: white; padding: 10px; display: inline-block; border-radius: 6px;">
                                <img src="	https://rcpereco.perennialcode.in/assets/img/logo.png" alt="Company Logo" width="140"
                                    style="display: block; max-width: 140px; height: auto;">
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style="padding: 30px 20px;">
                            <table cellpadding="0" cellspacing="0" width="100%"
                                style="background-color: #f9fafc; border: 1px solid #e0e0e0; border-radius: 4px; padding: 15px;">
                                <tr>
                                    <td>
                                        <p style="font-size: 16px; color: #444;">Hello ,
                                        </p>
                                        ${message
            ? `<p style="font-size: 14px; color: #333;">${message}</p>`
            : ""
          }
                                    </td>
                                   
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <tr>
                        <td style="background-color: #f5f5f5; padding: 15px 20px;">
                            <table width="100%" cellpadding="0" cellspacing="0">
                                <tr>
                                    <td align="left" style="font-size: 12px; color: #777;">
                                        2025 © Pereco. All Rights Reserved
                                    </td>
                                    <td align="right" style="font-size: 12px; color: #777;">
                                        Designed &amp; Developed by Perennial Code
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                </table>
            </td>
        </tr>
    </table>
</body>`,
        subject: subject,
        cc: emailList,
      };
      try {
        const response = await fetch(`${NOTIFICATIONS_API}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (result.status) {
          Swal.fire({
            title: "Success",
            text: "Your message was sent successfully.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            onClose();
          });
        } else {
          Swal.fire({
            title: "Error",
            text: result.Message || "Failed to send the message.",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Error sending message:", error);
        Swal.fire({
          title: "Error",
          text: "Something went wrong. Please try again!",
          icon: "error",
        });
      } finally {
        setLoadingBtn(false);
      }
    }
  };

  const handelCancel = () => {
    setSubject("");
    setMessage("");
  };

  return (
    <>
      {isOpen && (
        <div>
          <style>
            {`
        @media (max-width: 576px) {
          #offcanvasRightSendNotification {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightSendNotification {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightSendNotification {
            width: 30% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightSendNotification {
            width: 20% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightSendNotification {
            width:20% !important;
          }
        }
        `}
          </style>
          {loadingBtn && (
            <div
              className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
              style={{
                zIndex: 1050,
                backdropFilter: "blur(4px)",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
              }}
            >
              <Spin size="large" tip="Processing..." />
            </div>
          )}
          <div className="offcanvas-backdrop fade show" onClick={onClose} />
          <div
            className="offcanvas offcanvas-end show"
            id="offcanvasRightSendNotification"
            style={{ visibility: "visible" }}
          >
            <div className="offcanvas-header">
              <h4>Notification</h4>
              <button
                type="button"
                className="btn-close"
                // data-bs-dismiss="offcanvas"
                onClick={() => {
                  handelCancel();
                  onClose();
                }}
              />
            </div>
            <hr />
            <div className="offcanvas-body">
              <form>
                <div className="row">
                  <div className="col-12 mb-3">
                    <label className="form-label">Subject</label>
                    <input
                      placeholder="Subject "
                      className="form-control"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Body</label>
                    <textarea
                      className="form-control"
                      placeholder="Enter Meassage"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      rows={4}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-end mt-3">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    // data-bs-dismiss="offcanvas"
                    onClick={() => {
                      handelCancel();
                      onClose();
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-success"
                    onClick={handleSend}
                  >
                    {loadingBtn ? "Sending..." : "Send"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
SendNotification.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.func.isRequired,
};

export default SendNotification;
